import { useState } from "react";

export const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);
  const [selectedObject, setSelectedObject] = useState<any>(null);

  const handleOpenModal = (type: string, object?: any) => {
    setModalType(type);
    setSelectedObject(object || {});
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalType(null);
    setSelectedObject(null);
  };

  return {
    isModalOpen,
    modalType,
    selectedObject,
    handleOpenModal,
    handleCloseModal,
  };
};
